module.exports = __webpack_public_path__ + "static/media/ark_phone.c96fffee.svg";